<section class="log" aria-label="Sent emails">
  <div class="log-head">
    <span class="log-label">Sent emails</span>
    @if (total()) {
      <span class="log-count">{{ total() }}</span>
    }
  </div>

  @if (loading() && !rows().length) {
    <div class="log-state">Loading the email log…</div>
  } @else if (!rows().length) {
    <div class="log-state">No emails have been sent about this project yet.</div>
  } @else {
    <div class="log-rows">
      @for (row of rows(); track row.id) {
        <div class="log-row">
          <button
            class="log-row-main"
            type="button"
            (click)="toggle(row.id)"
            [attr.aria-expanded]="expanded().has(row.id)"
          >
            <span class="log-when">{{ row.sentAt | date: 'MMM d, y, h:mm a' }}</span>
            <span class="log-title">{{ row.title }}</span>
            <span class="log-sender">{{ row.sender }}</span>
            <span class="log-recipients">
              {{ row.recipients.length }} {{ row.recipients.length === 1 ? 'recipient' : 'recipients' }}
              @if (row.rejected.length) {
                <span class="log-rejected-count">· {{ row.rejected.length }} not sent</span>
              }
            </span>
          </button>

          @if (row.summary) {
            <div class="log-summary">{{ row.summary }}</div>
          }

          @if (expanded().has(row.id)) {
            <div class="log-detail">
              @if (row.recipients.length) {
                <div class="log-detail-label">Sent to</div>
                <div class="log-addresses">{{ row.recipients.join(', ') }}</div>
              }
              @if (row.rejected.length) {
                <div class="log-detail-label">Not sent</div>
                @for (rejection of row.rejected; track rejection.email) {
                  <div class="log-rejection">{{ rejection.email }} — {{ rejection.reason }}</div>
                }
              }
            </div>
          }
        </div>
      }
    </div>

    @if (hasMore()) {
      <button class="log-more" type="button" (click)="loadMore()" [disabled]="loading()">
        {{ loading() ? 'Loading…' : 'Show more' }}
      </button>
    }
  }
</section>
